import React from "react";
import pxToRem from "libs/pxToRem";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";

interface IProps {
  badgeContent: string;
  backgroundColor?: string;
  color?: string;
}

const Ellipse: React.FC<IProps> = ({
  badgeContent,
  backgroundColor,
  color,
}) => {
  return (
    <StyledBadge
      overlap="rectangular"
      badgeContent={badgeContent}
      $backgroundColor={backgroundColor}
      $color={color}
    />
  );
};

export default Ellipse;

const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== "$backgroundColor" && prop !== "$color",
})<{ $backgroundColor?: string; $color?: string }>(
  ({ theme, $backgroundColor, $color }) => ({
    display: "inline-block",
    paddingLeft: pxToRem(8),
    paddingRight: pxToRem(8),
    "& .MuiBadge-badge": {
      backgroundColor: $backgroundColor ?? theme.palette.primary.light,
      color: $color ?? "white",
      transform: "scale(1)",
      position: "relative",
    },
  })
);
